const formatCompaniesOptions = (companiesInvolved) => {
  let companiesOptions = [{ value: "", label: "Todas" }];
  Object.values(companiesInvolved).forEach((product) => {
    companiesOptions.push({ value: product.id, label: product.name });
  }, []);
  return companiesOptions;
};

const formatTradingTypesInvolved = (tradingTypesInvolved) => {
  let tradingOptions = [{ value: "", label: "Todos" }];
  Object.values(tradingTypesInvolved).forEach((trading) => {
    tradingOptions.push({ value: trading.value, label: trading.label });
  }, []);
  return tradingOptions;
};

const formatProductsOptions = (productsInvolved, brand) => {
  let productsOptions = [
    {
      value: "",
      label: "Todos",
    },
  ];

  Object.values(productsInvolved).forEach((product) => {
    if (!!brand) {
      if (product.brand.id === brand)
        productsOptions.push({
          value: product,
          label: `${product.name}, ${product.brand.name}, ${product.info} ${product.unitOfMeasurement.name}`,
        });
    } else {
      productsOptions.push({
        value: product,
        label: `${product.name}, ${product.brand.name}, ${product.info} ${product.unitOfMeasurement.name}`,
      });
    }
  });
  return productsOptions;
};

const formatBrandsOptions = (products) => {
  const brandsIds = [];
  let brandsOptions = [
    {
      value: "",
      label: "Todas",
    },
  ];
  Object.values(products).forEach((product) => {
    if (brandsIds.indexOf(product.brand.id) < 0) {
      brandsIds.push(product.brand.id);
      brandsOptions.push({
        value: product.brand.id,
        label: product.brand.name,
      });
    }
  }, []);
  return brandsOptions;
};

export {
  formatCompaniesOptions,
  formatProductsOptions,
  formatTradingTypesInvolved,
  formatBrandsOptions,
};
